import axios from 'axios'

const middlewareUrl = window?.configs?.['VITE_MIDDLEWARE_URL'] || import.meta.env.VITE_MIDDLEWARE_URL

// #region ticket holders
const getTicketHolders = async (uuidCorporation) => {
    let url = middlewareUrl
    url += '/ticketholders/?uuidCustomer=' + uuidCorporation

    return axios.get(url)
    .then(response => response.data)
}

const getTicketHolder = async (uuidTicketHolder) => {
    let url = middlewareUrl
    url += '/ticketholders/' + uuidTicketHolder

    return axios.get(url)
    .then(response => response.data)
}

const updateTicketHolder = async (uuidCorporation, ticketHolder, ifDeleteCompanyAssignment = false) => {
    let url = middlewareUrl
    url += '/ticketholders'

    let body = ticketHolder
    if (!ifDeleteCompanyAssignment) {
        body.companyAssignment = {
            uuidCustomer: uuidCorporation
        }
    }

    return axios.put(url, body)
    .then(response => response.data)
}

const createTicketHolder = async (uuidCorporation, newTicketHolder) => {
    let url = middlewareUrl
    url += '/ticketholders'

    let body = { newTicketHolder }

    body.newTicketHolder.companyAssignment = {
        uuidCustomer: uuidCorporation
    }
    body.newTicketHolder.identicalWithCustomer = true
    return axios.post(url, body)
    .then(response => response.data)
}

const getDuplicates = async (firstName, lastName, birthdate, postalCode) => {
    let url = middlewareUrl
    url += '/ticketholders/duplicates'

    url = new URL(url)
    url.searchParams.append('firstName', firstName)
    url.searchParams.append('lastName', lastName)
    if (birthdate) url.searchParams.append('birthdate', birthdate)
    if (postalCode) url.searchParams.append('postalCode', postalCode)

    return axios.get(url)
    .then(response => response.data)
}

const getAboTickets = async (uuidTicketHolder, activeTicketsOnly) => {
    let url = middlewareUrl
    url += '/ticketholders/' + uuidTicketHolder
    url += `/abotickets?activeOnly=${activeTicketsOnly}`

    return axios.get(url)
    .then(response => response.data)
}
// #endregion ticket holders

const getCompanies = async () => {
    let companiesUrl = middlewareUrl
    companiesUrl += '/companies'

    return axios.get(companiesUrl)
    .then(response => response.data)
}

//#region product variants
const getPriceDetails = async (idProductVariant, priceLevel, validAt, uuidCustomerCompany) => {
    let url = middlewareUrl
    url += '/product-variants/' + idProductVariant
    url += '/price-details'
    url += '?priceLevel=' + priceLevel
    url += '&validAt=' + validAt
    url += '&uuidCustomerCompany=' + uuidCustomerCompany

    return axios.get(url)
    .then(response => response.data)
}
// #endregion product variants

// #region account

/**
 * Get Credentials for a given user
 * @param {string} userId keyckloak user id
 * @returns list of credentials for the given user
 */
const getAccountCredentials = async () => {
    let url = middlewareUrl
    url += '/account/credentials'

    return axios.get(url)
    .then(response => response.data)
}

/**
 *
 * @param {string} userId keycloak user id
 * @param {string[]} requiredActions required actions to be set to the user e.g. 'CONFIGURE_TOTP'
 * @returns true for success
 */
const createAccountRequiredActions = async (requiredActions) => {
    let url = middlewareUrl
    url += '/account/required-actions'

    const body = requiredActions

    return axios.post(url, body)
    .then(response => response.data)
}
// #endregion account

//#region users
const handlePasswordChange = async (oldPassword, newPassword) => {
    let passwordChangeUrl = middlewareUrl
    passwordChangeUrl += '/users/reset-password'

    const passwordChangeBody = {
        oldPassword: oldPassword,
        newPassword: newPassword
    }

    return axios.post(passwordChangeUrl, passwordChangeBody)
}
//#endregion

//#region application requests
/**
 *
 * @param {string} uuidCorporation
 * @param {APPLICATION_MAILBOX_TYPE} mailboxType
 * @param {string} lastStatusUpdateFrom
 * @param {string} lastStatusUpdateUntil
 * @returns {ApplicationRequests[]}
 */
const getApplicationRequests = async (uuidCorporation, mailboxType, lastStatusUpdateFrom, lastStatusUpdateUntil) => {
    let url = middlewareUrl
    url += '/corporations/' + uuidCorporation
    url += '/applications'

    const params = {
        mailboxType,
        lastStatusUpdateFrom,
        lastStatusUpdateUntil
    }

    return axios.get(url, { params })
    .then(response => response.data)
}

/**
 * Reject application requests in a bulk
 * @param {string} uuidCorporation
 * @param {string[]} ids list of ids of applications that shall be rejected
 * @returns {Promise<object[]>} List of requests for applications whose status could not be changed
 */
const rejectApplicationRequests = async (uuidCorporation, ids) => {
    let url = middlewareUrl
    url += '/corporations/' + uuidCorporation
    url += '/applications'

    const body = {
        'reject': ids,
        'accept': []
    }

    return axios.put(url, body)
    .then(response => response.data)
}

/**
 * Accept application requests in a bulk
 * @param {string} uuidCorporation
 * @param {number[]} ids list of ids of applications that shall be rejected
 * @returns {Promise<object[]>} List of requests for applications whose status could not be changed
 */
const acceptApplicationRequests = async (uuidCorporation, ids) => {
    let url = middlewareUrl
    url += '/corporations/' + uuidCorporation
    url += '/applications'

    const body = {
        'accept': ids,
        'reject': []
    }

    return axios.put(url, body)
    .then(response => response.data)
}

/**
 *
 * @param {string} uuidCorporation
 * @param {string[]} ids
 * @param {object} patchData
 * @returns
 */
const updateApplicationRequest = async (uuidCorporation, ids, patchData ) => {
    let url = middlewareUrl
    url += '/corporations/' + uuidCorporation
    url += '/applications/' + ids

    return axios.patch(url, patchData)
    .then(response => response.data)
}
//#endregion application requests

//#region exports
const MiddlewareConnector = {
    getTicketHolders,
    getTicketHolder,
    getApplicationRequests,
    rejectApplicationRequests,
    acceptApplicationRequests,
    updateApplicationRequest,
    updateTicketHolder,
    createTicketHolder,
    getDuplicates,
    getAboTickets,
    getCompanies,
    getPriceDetails,
    handlePasswordChange,
    createAccountRequiredActions,
    getAccountCredentials,
    middlewareUrl
}
//#endregion

export {
    MiddlewareConnector
}
